// @flow
import type { Action, Client, GetState } from 'state/types';
import type { LicenseState } from 'state/types/licenseTypes';
import {
  ADD_LICENSE,
  ADD_LICENSE_FAIL,
  ADD_LICENSE_SUCCESS,
  CLEAR_IS_PENDING_RESPONSE,
  GET_EXTENSIS_ACCOUNT,
  GET_EXTENSIS_ACCOUNT_FAIL,
  GET_EXTENSIS_ACCOUNT_SUCCESS,
  GET_EXTENSIS_SYSTEMS,
  GET_EXTENSIS_SYSTEMS_FAIL,
  GET_EXTENSIS_SYSTEMS_SUCCESS,
  GET_LICENSING_INFO,
  GET_LICENSING_INFO_FAIL,
  GET_LICENSING_INFO_SUCCESS,
  SET_EXTENSIS_ACCOUNT,
  SET_EXTENSIS_ACCOUNT_FAIL,
  SET_EXTENSIS_ACCOUNT_SUCCESS,
  SET_EXTENSIS_SYSTEM,
  SET_EXTENSIS_SYSTEM_FAIL,
  SET_EXTENSIS_SYSTEM_SUCCESS,
  SET_IS_PENDING_RESPONSE,
} from 'state/types/licenseTypes';
import { API } from 'util/constants';

const initialState = {
  extensisAccount: null,
  isPendingResponse: false,
  licenseMaintenanceEndDate: null,
  extensisSystems: [],
};

export default function reducer(
  state: LicenseState = initialState,
  action: Action
) {
  switch (action.type) {
    case GET_EXTENSIS_ACCOUNT_SUCCESS:
      return {
        ...state,
        extensisAccount: action.payload.account,
      };
    case GET_EXTENSIS_SYSTEMS_SUCCESS:
      return {
        ...state,
        extensisSystems: action.payload,
      };
    case GET_LICENSING_INFO_SUCCESS:
      return {
        ...state,
        licenseMaintenanceEndDate: action.payload.maintenanceEndDate,
      };
    case CLEAR_IS_PENDING_RESPONSE:
      return {
        ...state,
        isPendingResponse: false,
      };
    case SET_IS_PENDING_RESPONSE:
      return {
        ...state,
        isPendingResponse: true,
      };
    default:
      return state;
  }
}

function getExtensisAccount(adminSession: ?string) {
  return {
    types: [
      GET_EXTENSIS_ACCOUNT,
      GET_EXTENSIS_ACCOUNT_SUCCESS,
      GET_EXTENSIS_ACCOUNT_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/extensisAccount`, {
        params: { session: adminSession },
      }),
  };
}

function setExtensisAccount(
  adminSession: string,
  account: string,
  password: string
) {
  return {
    types: [
      SET_EXTENSIS_ACCOUNT,
      SET_EXTENSIS_ACCOUNT_SUCCESS,
      SET_EXTENSIS_ACCOUNT_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/extensisAccount`, {
        params: { session: adminSession },
        data: { account, password },
      }),
  };
}

function getExtensisSystems(adminSession: string) {
  return {
    types: [
      GET_EXTENSIS_SYSTEMS,
      GET_EXTENSIS_SYSTEMS_SUCCESS,
      GET_EXTENSIS_SYSTEMS_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/extensisAccount/systems`, {
        params: { session: adminSession },
      }),
  };
}

function setExtensisSystem(adminSession: string, systemId: string) {
  return {
    types: [
      SET_EXTENSIS_SYSTEM,
      SET_EXTENSIS_SYSTEM_SUCCESS,
      SET_EXTENSIS_SYSTEM_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/extensisAccount/system/${systemId}`, {
        params: { session: adminSession },
      }),
  };
}

function getLicensingInfo(adminSession: ?string) {
  return {
    types: [
      GET_LICENSING_INFO,
      GET_LICENSING_INFO_SUCCESS,
      GET_LICENSING_INFO_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/extensisAccount/licensingInfo`, {
        params: { session: adminSession },
      }),
  };
}

function addLicense(adminSession: ?string, serialNumber: string) {
  return {
    types: [ADD_LICENSE, ADD_LICENSE_SUCCESS, ADD_LICENSE_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.put(`${API}/serial-number/${serialNumber}`, {
        params: { session: adminSession },
      }),
  };
}

function clearIsPendingResponse() {
  return {
    type: CLEAR_IS_PENDING_RESPONSE,
  };
}

function setIsPendingResponse() {
  return {
    type: SET_IS_PENDING_RESPONSE,
  };
}

export const actions = {
  addLicense,
  clearIsPendingResponse,
  getExtensisAccount,
  getExtensisSystems,
  getLicensingInfo,
  setExtensisAccount,
  setExtensisSystem,
  setIsPendingResponse,
};



// WEBPACK FOOTER //
// ./src/state/reducers/licenseReducer.js